export const DraftStatusIcon: React.FC = ({}) => {
    return(
      <svg width="18" height="18" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.375 0C0.61875 0 0.00687516 0.63 0.00687516 1.4L0 12.6C0 13.37 0.611875 14 1.36812 14H9.625C10.3813 14 11 13.37 11 12.6V4.2L6.875 0H1.375ZM6.1875 4.9V1.05L9.96875 4.9H6.1875Z" fill="#22638D"/>
      </svg>
  )
}